export default "__VITE_ASSET__DgvEvnaK__"